import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_mouse_detection_component = _resolveComponent("mouse-detection-component")
  const _component_playground_svg_view = _resolveComponent("playground-svg-view")

  return (_openBlock(), _createElementBlock("div", { style: {"display":"grid","place-content":"center"} }, [
    _createElementVNode("div", {
      class: "playground",
      style: _normalizeStyle(`grid-area: 1 / 1 / 2 / 2; display: grid; grid-template-columns: repeat(${ _ctx.puzzle.block.w }, 1fr); grid-template-rows: repeat(${ _ctx.puzzle.block.h }, 1fr);`)
    }, [
      _createCommentVNode("<template v-for=\"bit of puzzle.bits\">\n\t\t\t<bit :id=\"bit.id\"></bit>\n\t\t</template>\n\n\t\t<latch></latch>\n\n\t\t<template v-if=\"puzzle.candidate\">\n\t\t\t<candidate></candidate>\n\t\t</template>"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.block.w, (x) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.block.h, (y) => {
            return (_openBlock(), _createBlock(_component_mouse_detection_component, {
              x: x,
              y: y,
              style: {"z-index":"2"}
            }, null, 8 /* PROPS */, ["x", "y"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 4 /* STYLE */),
    _createVNode(_component_playground_svg_view, { style: {"grid-area":"1 / 1 / 2 / 2"} })
  ]))
}